import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import PurchasesSection from "./PurchasesSection";
import CategoryBudgetSection from "./CategoryBudgetSection";
import RoomCostsSection from "./RoomCostsSection";
import AdditionalCostsSection from "./AdditionalCostsSection";

export default function BudgetTab({ projectId, readOnly, budgetTotal, project, onProjectUpdate, clientHideTradeMarkup }) {
  const [purchases, setPurchases] = useState([]);
  const [costs, setCosts] = useState([]);

  const loadPurchases = () => api.get(`/projects/${projectId}/purchases`).then((r) => setPurchases(r.data)).catch(() => {});
  const loadCosts = () => api.get(`/projects/${projectId}/additional-costs`).then((r) => setCosts(r.data)).catch(() => {});
  useEffect(() => { loadPurchases(); loadCosts(); }, [projectId]);

  const purchasesTotal = purchases.reduce((s, p) => s + (p.client_price != null ? p.client_price : (p.cost || 0)), 0);
  const costsTotal = costs.reduce((s, c) => s + (c.amount || 0), 0);
  const totalSpent = purchasesTotal + costsTotal;
  const cap = budgetTotal || 0;
  const remaining = cap - totalSpent;
  const pct = cap ? Math.min(100, Math.round((totalSpent / cap) * 100)) : 0;

  const fmt = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

  return (
    <div className="max-w-4xl space-y-8" data-testid="budget-tab">
      <div className="grid sm:grid-cols-3 gap-px bg-[#EBE5E0] border border-[#EBE5E0]">
        {[
          ["Total Budget", fmt(cap)],
          ["Spent", fmt(totalSpent)],
          ["Remaining", fmt(remaining)],
        ].map(([k, v]) => (
          <div key={k} className="bg-white p-6">
            <p className="text-[11px] uppercase tracking-wider text-[#A68A6B]">{k}</p>
            <p className="font-serif text-3xl text-[#2B2622] mt-1" style={k === "Remaining" && remaining < 0 ? { color: "#9E4747" } : {}}>{v}</p>
          </div>
        ))}
      </div>

      <div>
        <div className="flex justify-between text-xs uppercase tracking-wider text-[#5C5651] mb-2">
          <span>Amount of Budget Spent</span><span>{pct}%</span>
        </div>
        <div className="h-2 bg-[#F2EFEB]">
          <div className="h-full" style={{ width: `${pct}%`, background: totalSpent > cap && cap ? "#9E4747" : "#A68A6B" }} />
        </div>
      </div>

      <CategoryBudgetSection projectId={projectId} readOnly={readOnly} purchases={purchases} />

      <PurchasesSection projectId={projectId} readOnly={readOnly} purchases={purchases} reload={loadPurchases}
        hideCols={!!clientHideTradeMarkup} project={project} onProjectUpdate={onProjectUpdate} />

      <RoomCostsSection purchases={purchases} />

      <AdditionalCostsSection projectId={projectId} readOnly={readOnly} costs={costs} reload={loadCosts} />
    </div>
  );
}
